export const COOKIE_NAME = "app_session_id";
export const ONE_YEAR_MS = 1000 * 60 * 60 * 24 * 365;
export const AXIOS_TIMEOUT_MS = 30_000;
export const UNAUTHED_ERR_MSG = 'Please login (10001)';
export const NOT_ADMIN_ERR_MSG = 'You do not have required permission (10002)';

// Stripe ACH fee structure (sender pays)
// ACH transfers: 0.8% of amount, capped at $5.00
export const STRIPE_ACH_FEE_PERCENT = 0.008; // 0.8%
export const STRIPE_ACH_FEE_CAP_CENTS = 500; // $5.00 cap

/**
 * Calculate the Stripe ACH processing fee for a given payment amount.
 * Fee is 0.8% of the transfer amount, capped at $5.00.
 * @param amountCents - The payment amount in cents (what the recipient receives)
 * @returns The fee in cents
 */
export function calculateStripeFee(amountCents: number): number {
  const fee = Math.round(amountCents * STRIPE_ACH_FEE_PERCENT);
  return Math.min(fee, STRIPE_ACH_FEE_CAP_CENTS);
}

/**
 * Calculate the total debit amount (payment + Stripe fee) for a given payment.
 * @param amountCents - The payment amount in cents (what the recipient receives)
 * @returns { paymentCents, feeCents, totalDebitCents }
 */
export function calculatePaymentWithFee(amountCents: number): {
  paymentCents: number;
  feeCents: number;
  totalDebitCents: number;
} {
  const feeCents = calculateStripeFee(amountCents);
  return {
    paymentCents: amountCents,
    feeCents,
    totalDebitCents: amountCents + feeCents,
  };
}
